import type { SaveState } from "../state/AnnotationStore";

/**
 * Derive the header save-status pill from the OfflineQueue's pending count.
 * The queue is the single writer of annotations.json, so its pending count
 * is the authoritative "is there unsynced work?" signal.
 */
export function pillState(args: {
  pendingCount: number;
  authExpired: boolean;
  everSynced: boolean;
}): SaveState {
  if (args.authExpired) return "auth-expired";
  if (args.pendingCount > 0) return "pending";
  if (args.everSynced) return "saved";
  return "idle";
}
